// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"b2d69a61","412":"a37a590c","453":"f9aaf8aa"}[chunkId] + ".chunk.js";
};